export default {
  EMAIL: 'EMAIL',
  EVP: 'EVP',
  PHONE: 'PHONE',
  CPF_CNPJ: 'CPF_CNPJ',
  ACCOUNT: 'ACCOUNT'
};
